import { dayjs } from 'element-plus';

function formatDate(date, format = "YYYY-MM-DD HH:mm:ss") {
  if (!date) return "";
  return dayjs(date || /* @__PURE__ */ new Date()).format(format);
}
function formatMoney(val, format = "\uFFE5", decimal = 2) {
  if (!val) return "";
  return `${format}${Number(val).toFixed(decimal)}`;
}

export { formatDate, formatMoney };
